import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Router } from 'react-router';

import { crossScreenFontSize, fontFace, fontFamilyMain } from './utils/styles';
import { injectGlobal } from 'styled-components';
import theme from './utils/theme';
import { FONT_FAMILY_MAIN, FONT_SIZE_TEXT, TRANSITION_DURATION, TRANSITION_FUNCTION } from './constants';
import SceneChanger from './components/SceneChanger';
import routes from './routes';
import Preloader from './components/Preloader';
import Cursor from './components/Cursor';
import history from './history';
import ResponsiveController from './utils/responsive-controller';
import SEOMetaData from './components/SEOMetaData';

injectGlobal`
	${fontFace(FONT_FAMILY_MAIN, FONT_FAMILY_MAIN)}
	${fontFace(FONT_FAMILY_MAIN, `${FONT_FAMILY_MAIN}-Light`, 300)}
	${fontFace(FONT_FAMILY_MAIN, `${FONT_FAMILY_MAIN}-Bold`, 700)}
	
	html {
		box-sizing: border-box;
	}
	
	body {
    font-weight: 300;
		-webkit-font-smoothing: antialiased;
		background-color: #fff;
		//transition: background 0.55s ease-out;
		${fontFamilyMain};
		${crossScreenFontSize(FONT_SIZE_TEXT)};
		
		&._dark {
			background-color: ${theme.colorDark};
		}
	}
	
	* {
        margin: 0;
        padding: 0;
	}
	
	[data-hide-on-animatoin] {
    transition: opacity ${TRANSITION_DURATION} ${TRANSITION_FUNCTION};	
	}
	
	@-webkit-keyframes autofill {
	  to {
	    background: transparent;
	    color: ${props => props.theme.colorText};
	  }
	}
	
	//input:-webkit-autofill {
	//    -webkit-animation-name: autofill;
	//    -webkit-animation-fill-mode: both;
	//}

	&._desktop * {
		cursor: none;
	}
`;

const Wrapper = styled.div`
  position: relative;
`;

class App extends React.Component {
  componentDidMount() {
    document.createElement('picture');
    picturefill(); // eslint-disable-line
  }

  state = {
    location: {},
  };

  handleRouteChange = location => {
    this.setState({ location });
  };

  render() {
    return (
      <Router history={history}>
        <ThemeProvider theme={theme}>
          <ResponsiveController>
            <Wrapper>
              <SEOMetaData location={this.state.location} />
              <Cursor />
              <Preloader />
              <SceneChanger routes={routes} onChange={this.handleRouteChange} />
            </Wrapper>
          </ResponsiveController>
        </ThemeProvider>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js